module.exports = __webpack_public_path__ + "img/cc-amex.699cbd46.png";